import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import {
  CertificationRequestStatus,
  UserRole,
} from '../data/UpuServiceDataCertificationRequestModel';
import { CertificationApi } from '../features/certification-request/certification-api';
import { UserApi } from '../features/user/user-api';
import { ROUTE_DATA } from './route-data';

export const requestDetailsGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const userApi = inject(UserApi);
  const certificationApi = inject(CertificationApi);

  const requestId = Number(route.paramMap.get('requestId'));
  const selfAssessmentUrl = router.createUrlTree([
    ROUTE_DATA.requests.path,
    ROUTE_DATA['self-assessment'].path,
    requestId,
  ]);

  const requestStatus = await lastValueFrom(
    certificationApi.getCertificationRequestStatus(requestId),
  );

  const isSecurityFocalPoint =
    userApi.userRole() === UserRole.SecurityFocalPoint;

  if (
    isSecurityFocalPoint &&
    requestStatus === CertificationRequestStatus.Draft
  ) {
    return selfAssessmentUrl;
  }

  return true;
};
